const DefaultEventTypes = {
  ATTEMPTED: 'attempted',
  SUCCESS: 'success',
  FAILED: 'fail',
  UNKNOWN_FAILURE: 'unknown_failure',
};

module.exports.DefaultEventTypes = DefaultEventTypes;
